import React, { Component } from 'react'
import { Grid , Box, IconButton} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import useStyles from './styles/LargeVideoPreviewBoxStyle'
import { getDuration }  from '../../../services/Utils'

// A react component representing a 'video preview object' that has a title, duration,
// preview image and an optional description.
class LargeVideoPreviewBox extends Component {
  render() {
    const classes = this.props.classes;
    return (
      <Grid
        container
        onClick={()=> this.props.onVideoClicked()}
        justify="center"
        alignItems="center"
        className={`${classes.container}`}
        style={{cursor: 'pointer', height: this.props.height}}
      >
        <Grid
          className={classes.previewImageContainer}
          container
          item
        >
        <Box className={`${classes.gradientBox}`}/>
        <img
          alt={this.props.videoDetails.title}
          className={classes.previewImage}
          src={this.props.videoDetails.image}
        />
        </Grid>

        <Grid item className={`${classes.playButton} play-button`}>
          <IconButton className={classes.playButton}>
            <PlayArrowIcon className={`${classes.playButtonArrow} play-arrow`}/>
          </IconButton>
        </Grid>

        <Box textAlign='center' className={`${classes.durationBox} duration-box`}>
          {getDuration(this.props.videoDetails.duration)}
        </Box>

        <Grid item>
          <Box className={`${classes.title} section-three-items-item-large-title`}>
            {this.props.videoDetails.title}
          </Box>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(useStyles)(LargeVideoPreviewBox)
